import 'slick-carousel';
import 'imagesloaded';
import 'jquery-viewport-checker';
import '../vender/sticky-kit.min.js';
import 'isotope-layout';

export default {
  init() {
    // JavaScript to be fired on all pages

    var offset = 0;

    if ( $(window).width() < 768 ) {
      offset = 0;
    } else {
      offset = -50;
    }

    // Animate Content in
    // $('.animate-block').viewportChecker({
    //   classToAdd: 'come-in',
    //   offset: offset,
    // });

      $('.animate-show').viewportChecker({
          //classToAdd: 'come-in',
          offset: offset,
          callbackFunction: function(elem, action){
              setTimeout(function(){
                  if(action == 'add')
                      $(elem).addClass('visible animated fadeIn');
                  else
                      $(elem).removeClass('visible animated fadeIn');
              }, 500);
          },
      });

    // eslint-disable-next-line no-undef
    //console.log(ajax_object);

    // $('.grid').isotope({
    //   itemSelector: '.grid-item',
    //   percentPosition: true,
    //   masonry: {
    //     columnWidth: '.grid-sizer',
    //   },
    // });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    //
    // Fade on link clicks
    $('.main-content').fadeIn(2000);
    
    var newLocation = '';

    $('.menu-item a').click(function(event) {
      event.preventDefault();

      newLocation = this.href;

      $('ul.sub-menu').fadeOut(100);
      $('.main-content').fadeOut(400, newPage);

      $('.mobileNavigation').removeClass('mobile-open');

    });
    
    function newPage() {
      window.location = newLocation;
    }

    $(window).bind('pageshow', function() {
      // This event is called only by FireFox. Because Firefox doesn't reload the page when the user uses the back button,
      // or when we call history.go.back(), we need to force the reload for the applicatino to work similar to Chrome and IE (11 at least).

      // Doc: https://developer.mozilla.org/en-US/docs/Listening_to_events_in_Firefox_extensions
      // location.reload();
      $('.main-content').fadeIn(2000);
      $('.footer').fadeIn(2000);
  }); 

    // Firefox back button fix
    // window.onload = function () {
    //   if (typeof history.pushState === "function") {
    //       history.pushState("jibberish", null, null);
    //       window.onpopstate = function () {
    //           history.pushState('newjibberish', null, null);
    //           // Handle the back (or forward) buttons here
    //           // Will NOT handle refresh, use onbeforeunload for this.
    //         $('footer').fadeIn(2000);
    //       };
    //   }
    // }

    // window.onbeforeunload = function () {
    //   $('.main-content').fadeIn(2000);
    //   $('footer').fadeIn(2000);
    //   console.log('backfired');
    // }

    //
    // Smooth scroll
    $('a[href*="#"]')
     // Remove links that don't actually link to anything
     .not('[href="#"]')
     .not('[href="#0"]')
     .click(function(event) {
       // On-page links

       // Remove active menu item
        $('li').removeClass('current-menu-item');

       if (
         location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
         &&
         location.hostname == this.hostname
       ) {
         // Figure out element to scroll to
         var target = $(this.hash);
         target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
         // Does a scroll target exist?
        
        $(this).parent().addClass('current-menu-item');

         if (target.length) {
           // Only prevent default if animation is actually gonna happen
           event.preventDefault();
           $('html, body').animate({
             scrollTop: target.offset().top - 30,
           }, 1000 );
         }
       }
     });

    $('.hamburger').on("click", function() {
        $(this).toggleClass("is-active");
        $('.site-header--mobileNav').toggleClass("active-nav");

        if($(".site-header--mobileNav").hasClass('active-nav')){
          $('.hamburger').text('Close');
          $("body").css('overflow','hidden');
        } else {
          $('.hamburger').text('Menu');
          $("body").css('overflow','initial');
        }

    });

    $('#close').on("click", function(e) {
        e.preventDefault();
          
          setTimeout( function(){
            $('#contact').removeClass("active-contact");
            //$('.contact__inner--details').removeClass('animated fadeInRight');
          }, 200);

          $('.site-header--mobileNav').removeClass("active-nav");
          $('.hamburger').text('Menu');
          $("body").css('overflow','initial');
    });

    //var enable = '';

    $('#contact-nav-item a').on("click", function(e) {
        e.preventDefault();
        $('#contact').toggleClass("active-contact");
        
        setTimeout( function(){
          //$('.contact__inner--details').toggleClass('animated fadeInRight');
        }, 500);

          $('.main').click(function() {
            $('#contact').removeClass("active-contact");
            //console.log(enable);
          });

        // enable = true;

        // if(enable === true) {
        //   $('.main').click(function() {
        //     $('#contact').toggleClass("active-contact");
        //     console.log(enable);
        //   });
        //   enable = false;
        // } else {
        //   console.log(enable);
        // }

    });
    


    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      //
    } else {
      $(".projects__project, .overview__project").mouseenter(function() {
          $(".projects, .overview").addClass('hover');
          $(this).addClass('active');
        }).mouseleave(function() {
          $(".projects, .overview").removeClass('hover');
          $(this).removeClass('active');
      });
    }

    // $('.grid').masonry({
    //   // options...
    //   itemSelector: '.grid-item',
    //   percentPosition: true,
    // });

    // init Masonry
    // var $grid = $('.grid').masonry({
    //   // options...
    //   itemSelector: '.grid-item',
    //   columnWidth: '.grid-sizer',
    //   percentPosition: true,
    // });
    // // layout Masonry after each image loads
    // $grid.imagesLoaded().progress( function() {
    //   $grid.masonry('layout');
    // });


    // $('.grid').isotope({
    //   itemSelector: '.grid-item',
    //   percentPosition: true,
    //   masonry: {
    //     columnWidth: '.grid-sizer',
    //   },
    // });

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js